import styled, { css } from 'styled-components';
import { rem } from 'polished';

export const Num = styled.div.attrs({
  role: 'presentation',
})`
  margin-bottom: 20px;
  font-family: ${props => props.theme.condensedFont};
  font-size: ${props => rem(props.fontSize)};
  color: ${props => props.theme.darkGray};

  ${props => props.styles && css`
    ${props.styles};
  `}
`;

Num.defaultProps = {
  fontSize: 30,
};

export default Num;
